import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m399-174 271-327H495l34-274-246 356h151l-35 245Zm-51-170H215q-24 0-36-21-11-21 3-41l360-519q9-13 23-17 13-4 27 1t22 18q8 14 6 28l-40 319h166q26 0 36 22 10 23-5 42L384-39q-10 12-23 15-14 3-28-3-12-6-20-18-7-12-5-27l40-272Zm128-129Z"/>',
  f: '<path d="M348-344H215q-24 0-36-21-11-21 3-41l360-519q9-13 23-17 13-4 27 1t22 18q8 13 6 28l-40 319h166q25 0 36 22 10 23-5 42L384-39q-9 12-23 15t-28-3q-12-5-19-18-8-12-6-27l40-272Z"/>',
};

export default data;
